export interface RatingProps {
  rate: number
  setRate: React.Dispatch<React.SetStateAction<number>>
}

export const useRating = (props: RatingProps) => {
  const { setRate } = props

  const stars = [5, 4, 3, 2, 1]

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRate(Number(event.target.value))
  }

  return {
    ...props,
    stars,
    handleChange,
  }
}
